import React from "react";
import { hotelCategoryService } from "../jwt/_services/hotel/hotelCategoryService";

export const hotelCategoryProvider = {
	getOptions,
	getItem,
};

async function getOptions(customFilter = {}) {
	try {
		const udn = localStorage.getItem('selectedUdn') === 'undefined' ? null : JSON.parse( localStorage.getItem('selectedUdn') );

		if (Object.keys(customFilter).length === 0 && udn !== null)
			customFilter = { item:{ udn:{ id : udn.id }}}

		const listItems = await hotelCategoryService.getOptions(customFilter);

		return listItems.data.map(({id='', code='', title=''}) => ({
				id,
				value: ( code || '' ) + '-' + ( title || '' ),
				label: <label>{ code?.toUpperCase() + ' - '  } <b>{ title }</b> </label>
			})
		);
	} catch (error) {
		console.log(error.message)
	}
}

async function getItem(id) {
	try {
		const item = await hotelCategoryService.getItem(id);
		const  label = item.title != null ? item.code + ' - ' + item.title : item.code
		return (
			{
				id: item.id,
				value: item.code,
				label: <div><label>{ label }</label></div>
			}
		);
	} catch (error) {
		console.log(error.message)
	}
}